import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Terminal.module.scss'

type LineKind = 'command' | 'field' | 'comment'

interface TerminalWindowProps {
  title: string
  children: React.ReactNode
}

interface TerminalLineProps {
  kind: LineKind
  children: React.ReactNode
  label?: string
}

const kindMap: Record<LineKind, string> = {
  command: styles.command,
  field: styles.field,
  comment: styles.comment,
}

export const TerminalWindow: React.FC<TerminalWindowProps> = ({ title, children }) => (
  <div className={styles.window}>
    <div className={styles.titleBar}>
      <span className={styles.dots} aria-hidden="true"><i /><i /><i /></span>
      <span className={styles.title}>{title}</span>
    </div>
    <div className={styles.body}>{children}</div>
  </div>
)

export const TerminalLine: React.FC<TerminalLineProps> = ({ kind, children, label }) => (
  <div className={cx(styles.line, kindMap[kind])}>
    {kind === 'command' && <span className={styles.prompt}>$</span>}
    {label && <span className={styles.label}>{label}</span>}
    <span className={styles.text}>{children}</span>
  </div>
)
